import { Taxonomy } from "domain";

export const initState = {
    current: null,
    list: [],
    total: 0,
    isLoading: false,
    hasFailed: false
};

export default function taxonomyReducer(state = initState, action) {
    const { type, payload } = action;

    switch (type) {
        case 'CLEAR_TAXONOMY_PENDING': {
            return { ...initState };
        }

        case 'SET_TAXONOMY_PENDING':
        case 'GET_TAXONOMY_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'SET_TAXONOMY_REJECTED':
        case 'GET_TAXONOMY_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'SAVE_TAXONOMY_FULFILLED':
        case 'SET_TAXONOMY_FULFILLED':
        case 'GET_TAXONOMY_FULFILLED': {
            return { 
                ...state, 
                current: new Taxonomy(payload), 
                isLoading: false, 
                hasFailed: false 
            };
        }

        case 'LIST_TAXONOMY_PENDING': {
          return { ...state, isLoading: true, hasFailed: false };
        }
      
        case 'LIST_TAXONOMY_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }
      
        case 'LIST_TAXONOMY_FULFILLED': {
            return {
                ...state,
                list: payload.map(item => new Taxonomy(item)),
                isLoading: false,
                hasFailed: false
            };
        }

        case 'DELETE_TAXONOMY_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'DELETE_TAXONOMY_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'DELETE_TAXONOMY_FULFILLED': {
            return { 
                ...state, 
                current: state.current && state.current.objectId === payload.taxonomyId ? null : state.current,
                list: state.list.filter(taxonomy => taxonomy.objectId !== payload.taxonomyId),
                isLoading: false, 
                hasFailed: false 
            };
        }

        default: {
            return state;
        }
    }
}
